import { defineMessages } from 'react-intl';

export const responseMessages = defineMessages({
  googleDrive: {
    id: '',
    description: 'Body message on Google Drive pop up modal for external service integration',
    defaultMessage: 'To use your Google Drive files, you must install and launch the {brandName} application. Click Continue to install the application, once there Install then Launch the application.',
  },
  evernote: {
    id: '',
    description: 'Body message on Evernote pop up modal, external service integration',
    defaultMessage: 'To use your Evernote files, you must first link your {brandName} account. We will also create a {brandName} notebook. Anytime you send or receive a document, it will be backed up as a note.',
  },
  dropbox: {
    id: '',
    description: 'Body message on Dropbox pop up modal, external service integration',
    defaultMessage: 'To use your Dropbox files, you must first link your {brandName} account. We will also create a {brandName} folder in your Dropbox. Anytime you send or receive a document, it will be backed up in your Dropbox account.',
  },
  box: {
    id: '',
    description: 'Body message on Dropbox pop up modal, external service integration',
    defaultMessage: 'To use your Box files, you must first authorize {brandName} to access files in your Box account.',
  },
  oneDrive: {
    id: '',
    description: 'Body message on Dropbox pop up modal, external service integration',
    defaultMessage: 'To use your OneDrive files, you must first link your {brandName} account. We will also create a {brandName} folder in your OneDrive. Anytime you send or receive a document, it will be backed up in your OneDrive account.',
  },
  googleDriveReAuth: {
    id: '',
    description: 'Body message on Google Drive pop up modal for Re-authorization external service integration',
    defaultMessage: 'Google Drive has upgraded the way they handle authorizations. As a result you must reauthorize {brandName} to access files in your Drive account.',
  },
  boxReAuth: {
    id: '',
    description: 'Body message on Box pop up modal for Re-authorization external service integration',
    defaultMessage: 'Box.net has upgraded the way they handle authorizations. As a result you must reauthorize {brandName} to access files in your Box account.',
  },
  defaultError: {
    id: '',
    description: 'Authorization error on external services integration. not access denied',
    defaultMessage: 'Sorry something went wrong, please try again later. Error: { authResultError }',
  },
});
